/** @format */

export const DEMO_ROUTE_NAME = 'DemoRoute';
export const DEMO_SASS_ROUTE_NAME = 'DemoSassRoute';
export const DEMO_PINIA_ROUTE_NAME = 'DemoPiniaRoute';
export const DEMO_ERROR_404_ROUTE_NAME = 'DemoError404Route';

export const LOGIN_NAME = 'Login';

export const REDIRECT_NAME = 'Redirect';

export const PARENT_LAYOUT_NAME = 'ParentLayout';

export const PAGE_NOT_FOUND_NAME = 'PageNotFound';

// 路由白名单
export const whiteNameList = [
	DEMO_ERROR_404_ROUTE_NAME,
	DEMO_ROUTE_NAME,
	DEMO_PINIA_ROUTE_NAME,
	DEMO_SASS_ROUTE_NAME,
	LOGIN_NAME,
	'icons',
	'error',
	'error-404',
] as const; // no redirect whitelist

export type WhiteNameList = typeof whiteNameList;

export type WhiteName = (typeof whiteNameList)[number];
